import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoReviewsRpcClientContext } from "@redotech/redo-merchant-review-app/rpc-client";
import { MarketingPermissions } from "@redotech/redo-model/permissions";
import { ReviewStatus } from "@redotech/redo-review-db-schema/review";
import { createContext, memo, ReactNode } from "react";

export const ReviewsToReviewContext = createContext<number>(0);

export const ReviewsToReviewService = memo(function ReviewsToReviewService({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const team = useRequiredContext(TeamContext);
  const redoReviewsRpcClient = useRequiredContext(RedoReviewsRpcClientContext);

  const canViewMarketing = useHasPermission(
    MarketingPermissions.VIEW_MARKETING,
  );

  const countOfReviewsNeedingReview = useLoad(async () => {
    if (!canViewMarketing) {
      return 0;
    }
    if (team?.platform !== "shopify") {
      return 0;
    }
    const reviews = await redoReviewsRpcClient.getReviews({
      teamId: team._id,
      statuses: [ReviewStatus.MANUAL_REVIEW],
    });
    return reviews.reviews.length;
  }, [team, redoReviewsRpcClient]);

  return (
    <ReviewsToReviewContext.Provider
      value={countOfReviewsNeedingReview.value || 0}
    >
      {children}
    </ReviewsToReviewContext.Provider>
  );
});
